<template>
    <section class="bg-white container-global q-py-xl">
        <div class="">
            <div class="header_section">
                <h3 class="header_section-title">
                    الاستثمار في تجربة المستخدم ينعكس على جميع قطاعات المنشأة
                </h3>
                <p class="header_section-description">
                    تجربة المستخدم الممتازة ما تفيد العميل فقط، بل تحسّن الأداء، وتقلل التكاليف، ونرفع الإيرادات،
                    وتدعم فرق العمل
                </p>
            </div>
        </div>
        <div class="q-mx-auto col-sm-12 col-md-11 col-lg-10">
            <div class="upgrade-features-row">
                <div tabindex="0"  role="button"  class="upgrade-feature-card" :class="{ 'upgrade-feature-card--active': activeFeatureIndex === 0 }"
                    @click="setActiveFeature(0)">
                    <div class="upgrade-feature-label">الدعم</div>
                    <img src="@/assets/images/new-home/upgrade_features_1.svg" alt="نص بديل للدعم"
                        class="upgrade-feature-icon" />
                </div>
                <div tabindex="0"  role="button"  class="upgrade-feature-card" :class="{ 'upgrade-feature-card--active': activeFeatureIndex === 1 }"
                    @click="setActiveFeature(1)">
                    <div class="upgrade-feature-label">الشمولية</div>
                    <img src="@/assets/images/new-home/upgrade_features_2.svg" alt="نص بديل الشمولية"
                        class="upgrade-feature-icon" />
                </div>
                <div tabindex="0"  role="button"  class="upgrade-feature-card" :class="{ 'upgrade-feature-card--active': activeFeatureIndex === 2 }"
                    @click="setActiveFeature(2)">
                    <div class="upgrade-feature-label">الرضا</div>
                    <img src="@/assets/images/new-home/upgrade_features_3.svg" alt="نص بديل الولاء"
                        class="upgrade-feature-icon" />
                </div>
                <div tabindex="0"  role="button"  class="upgrade-feature-card" :class="{ 'upgrade-feature-card--active': activeFeatureIndex === 3 }"
                    @click="setActiveFeature(3)">
                    <div class="upgrade-feature-label">القرارات</div>
                    <img src="@/assets/images/new-home/upgrade_features_4.svg" alt="نص بديل القرارات"
                        class="upgrade-feature-icon" />
                </div>
                <div tabindex="0"  role="button"  class="upgrade-feature-card" :class="{ 'upgrade-feature-card--active': activeFeatureIndex === 4 }"
                    @click="setActiveFeature(4)">
                    <div class="upgrade-feature-label">الصدارة</div>
                    <img src="@/assets/images/new-home/upgrade_features_5.svg" alt="نص بديل الجوائز"
                        class="upgrade-feature-icon" />
                </div>
                <div tabindex="0"  role="button"  class="upgrade-feature-card" :class="{ 'upgrade-feature-card--active': activeFeatureIndex === 5 }"
                    @click="setActiveFeature(5)">
                    <div class="upgrade-feature-label">الإيرادات</div>
                    <img src="@/assets/images/new-home/upgrade_features_6.svg" alt="نص بديل الإيرادات"
                        class="upgrade-feature-icon" />
                </div>
                <div tabindex="0"  role="button"  class="upgrade-feature-card" :class="{ 'upgrade-feature-card--active': activeFeatureIndex === 6 }"
                    @click="setActiveFeature(6)">
                    <div class="upgrade-feature-label"> التوجيه</div>
                    <img src="@/assets/images/new-home/upgrade_features_7.svg" alt="نص بديل بناء المنتج"
                        class="upgrade-feature-icon" />
                </div>
            </div>
        </div>
        <div class="upgrade-featured-section">
            <div class="upgrade-featured-content">
                <!-- الدعم Content -->
                <transition name="fade-slide" mode="out-in">
                    <div class="upgrade-featured-right" v-if="activeFeatureIndex === 0" key="support">
                        <h2 class="upgrade-featured-title">قلّل عدد الشكاوى بدلاً من سرعة معالجتها</h2>
                        <div class="upgrade-featured-desc">
                            إذا كانت واجهة المستخدم معقدة أو مربكة، المستخدم يتجه مباشرة للدعم الفني.
                            أداة أكواد تكشف لك السلبيات بشكل استباقي </div>
                        <ul class="upgrade-featured-list">
                            <li><img src="@/assets/images/new-home/upgrade_features_currect.svg" alt="check" />
                                تقارير تفصيلية توضح لك نقطة الانسحاب (اللحظة اللي طلع فيها العميل من الموقع)
                            </li>
                            <li><img src="@/assets/images/new-home/upgrade_features_currect.svg" alt="check" />
                                إيجاد حل جذري بدلاً من معالجة كل شكوى
                            </li>
                            <li><img src="@/assets/images/new-home/upgrade_features_currect.svg" alt="check" />
                                توفير موارد مادية وبشرية في الدعم الفني
                            </li>
                        </ul>
                        <!-- <div class="upgrade-featured-btns">
                            <button class="primary_btn_outline">تواصل معنا</button>
                            <button class="primary_btn">اعرف اكثر</button>
                        </div> -->
                    </div>

                    <!-- الشمولية Content -->
                    <div class="upgrade-featured-right" v-else-if="activeFeatureIndex === 1" key="inclusivity">
                        <h2 class="upgrade-featured-title">صمّم للجميع، وليس لفئة واحدة</h2>
                        <div class="upgrade-featured-desc">
                            كبار السن والأشخاص ذوي الإعاقة يحتاجون خصائص تلبّي احتياجاتهم، مختبر أكواد يساعدك تعرف هذي
                            الاحتياجات. </div>
                        <ul class="upgrade-featured-list">
                            <li><img src="@/assets/images/new-home/upgrade_features_currect.svg" alt="check" />
                                تصميم شامل يراعي كل فئات المجتمع</li>
                            <li><img src="@/assets/images/new-home/upgrade_features_currect.svg" alt="check" />
                                اختبارات واقعية حسب الفئة </li>
                            <li><img src="@/assets/images/new-home/upgrade_features_currect.svg" alt="check" />
                                واجهة مستخدم يستفيد منها كل فرد </li>
                        </ul>
                        <!-- <div class="upgrade-featured-btns">
                            <button class="primary_btn_outline">تواصل معنا</button>
                            <button class="primary_btn">اعرف اكثر</button>
                        </div> -->
                    </div>

                    <!-- الولاء Content -->
                    <div class="upgrade-featured-right" v-else-if="activeFeatureIndex === 2" key="loyalty">
                        <h2 class="upgrade-featured-title">إذا المستخدم شعر بالرضا عن التجربة، يصير أفضل مسوّق لك
                            لخدمتك!</h2>
                        <div class="upgrade-featured-desc">
                            كل ما كانت التجربة أسهل وأوضح، زادت احتمالية رجوعه وتوصيته بخدمتك. </div>
                        <ul class="upgrade-featured-list">
                            <li><img src="@/assets/images/new-home/upgrade_features_currect.svg" alt="check" />
                                الانطباع الأولي يدوم، وأكواد تساعدك لتحسين هذا الانطباع</li>
                            <li><img src="@/assets/images/new-home/upgrade_features_currect.svg" alt="check" />
                                تقليل معدل الانسحاب وزيادة التفاعل على المدى ال طويل</li>
                            <li><img src="@/assets/images/new-home/upgrade_features_currect.svg" alt="check" />
                                بناء علاقة مستمرة بدل من تفاعل مؤقت</li>
                        </ul>
                        <!-- <div class="upgrade-featured-btns">
                            <button class="primary_btn_outline">تواصل معنا</button>
                            <button class="primary_btn">اعرف اكثر</button>
                        </div> -->
                    </div>

                    <!-- القرارات Content -->
                    <div class="upgrade-featured-right" v-else-if="activeFeatureIndex === 3" key="decisions">
                        <h2 class="upgrade-featured-title">كل ما كانت البيانات أوضح، كانت قراراتك أدق.</h2>
                        <div class="upgrade-featured-desc">
                            بدل ما تعتمد على التخمين أو الرأي الشخصي، أداة أكواد تعطبك نتائج حقيقية عن تجربة المستخدم.
                        </div>
                        <ul class="upgrade-featured-list">
                            <li><img src="@/assets/images/new-home/upgrade_features_currect.svg" alt="check" />
                                تقارير تفصيلية وتحليلية مدعومة بسلوك المستخدم الفعلي</li>
                            <li><img src="@/assets/images/new-home/upgrade_features_currect.svg" alt="check" />
                                بيانات حقيقية وواقعية تشعرك بالثقة وأنت تتخذ قرارك </li>
                            <li><img src="@/assets/images/new-home/upgrade_features_currect.svg" alt="check" />
                                تقدر تختبر منتجاتك الرقمية وتتأكد من جودتها قبل إطلاقها الرسمي</li>
                        </ul>
                        <!-- <div class="upgrade-featured-btns">
                            <button class="primary_btn_outline">تواصل معنا</button>
                            <button class="primary_btn">اعرف اكثر</button>
                        </div> -->
                    </div>

                    <!-- الجوائز Content -->
                    <div class="upgrade-featured-right" v-else-if="activeFeatureIndex === 4" key="awards">
                        <h2 class="upgrade-featured-title">
                            تصدّر مشهد التحول الرقمي والفوز بالجوائز المتخصصة في تجربة المستخدم هدف لكل منشأة تسعى
                            لتحسين سمعتها </h2>
                        <div class="upgrade-featured-desc">
                            أداة أكواد تساعدك على تحقيق هذا الهدف. </div>
                        <ul class="upgrade-featured-list">
                            <li><img src="@/assets/images/new-home/upgrade_features_currect.svg" alt="check" />
                                حلول أكواد تعتمد على معايير محلية ودولية</li>
                            <li><img src="@/assets/images/new-home/upgrade_features_currect.svg" alt="check" />
                                نتائج ملموسة وتحقق نقاط عالية في معايير تقييم المنافسات</li>
                            <li><img src="@/assets/images/new-home/upgrade_features_currect.svg" alt="check" />
                                واجهة استخدام فعّالة تعكس احترافية المنشأة</li>
                        </ul>
                        <!-- <div class="upgrade-featured-btns">
                            <button class="primary_btn_outline">تواصل معنا</button>
                            <button class="primary_btn">اعرف اكثر</button>
                        </div> -->
                    </div>

                    <!-- الإيرادات Content -->
                    <div class="upgrade-featured-right" v-else-if="activeFeatureIndex === 5" key="revenue">
                        <h2 class="upgrade-featured-title">
                            رفع الإيرادات وخفض التكاليف . </h2>
                        <div class="upgrade-featured-desc">
                            كل خطوة محسوبة في تجربة المستخدم، والوصول للمعلومات والبيانات المهمة يعطيك القدرة على اتخاذ
                            قرارات بسيطة، لكنها تصنع نجاحات جبارة في رفع الإيرادات وخفض التكاليف. </div>
                        <ul class="upgrade-featured-list">
                            <li><img src="@/assets/images/new-home/upgrade_features_currect.svg" alt="check" />
                                تقليل التكاليف التشغيلية الناتجة عن ضعف رحلة العميل</li>
                            <li><img src="@/assets/images/new-home/upgrade_features_currect.svg" alt="check" />
                                تلبية احتياجات المستخدم، واللي ينتج عنه زيادة معدلات التحويل ونمو الإيرادات</li>
                            <li><img src="@/assets/images/new-home/upgrade_features_currect.svg" alt="check" />
                                تحقيق عائد أعلى من نفس الموارد الحالية</li>
                        </ul>
                        <!-- <div class="upgrade-featured-btns">
                            <button class="primary_btn_outline">تواصل معنا</button>
                            <button class="primary_btn">اعرف اكثر</button>
                        </div> -->
                    </div>

                    <!-- بناء المنتج Content -->
                    <div class="upgrade-featured-right" v-else-if="activeFeatureIndex === 6" key="product">
                        <h2 class="upgrade-featured-title">
                            بدل الاعتماد على التوقعات، يصير العمل موجه لتلبية احتياجات حقيقية ومحددة. </h2>
                        <div class="upgrade-featured-desc">
                            تحسين تجربة المستخدم يعطي فريق التصميم والتطوير والتخطيط رؤية واضحة حول احتياج العميل
                            الحقيقي. بدل الاعتماد على التوقعات، يصير العمل موجه لتلبية احتياجات حقيقية ومحددة.
                        </div>
                        <ul class="upgrade-featured-list">
                            <li><img src="@/assets/images/new-home/upgrade_features_currect.svg" alt="check" />
                                خدمات مبنية على دراسة واحتياجات فعلية</li>
                            <li><img src="@/assets/images/new-home/upgrade_features_currect.svg" alt="check" />
                                تقليل إعادة تصميم واجهة المستخدم والتعديلات المتكررة</li>
                            <li><img src="@/assets/images/new-home/upgrade_features_currect.svg" alt="check" />
                                منتج يخدم المستخدم بالشكل الصحيح من أول تفاعل</li>
                        </ul>
                        <!-- <div class="upgrade-featured-btns">
                            <button class="primary_btn_outline">تواصل معنا</button>
                            <button class="primary_btn">اعرف اكثر</button>
                        </div> -->
                    </div>
                </transition>

                <div class="upgrade-featured-left">
                    <!-- <transition name="fade-scale" mode="out-in"> -->
                    <div class="upgrade-featured-background-img" v-if="activeFeatureIndex === 0" key="img-0">
                        <img src="@/assets/images/upgrade-featured/0.svg" alt="الدعم" />
                    </div>
                    <div class="upgrade-featured-background-img" v-else-if="activeFeatureIndex === 1" key="img-1">
                        <img src="@/assets/images/upgrade-featured/1.svg" alt="الشمولية" />
                    </div>
                    <div class="upgrade-featured-background-img" v-else-if="activeFeatureIndex === 2" key="img-2">
                        <img src="@/assets/images/upgrade-featured/2.svg" alt="الولاء" />
                    </div>
                    <div class="upgrade-featured-background-img" v-else-if="activeFeatureIndex === 3" key="img-3">
                        <img src="@/assets/images/upgrade-featured/3.svg" alt="القرارات" />
                    </div>
                    <div class="upgrade-featured-background-img" v-else-if="activeFeatureIndex === 4" key="img-4">
                        <img src="@/assets/images/upgrade-featured/4.svg" alt="الجوائز" />
                    </div>
                    <div class="upgrade-featured-background-img" v-else-if="activeFeatureIndex === 5" key="img-5">
                        <img src="@/assets/images/upgrade-featured/5.svg" alt="الإيرادات" />
                    </div>
                    <div class="upgrade-featured-background-img" v-else-if="activeFeatureIndex === 6" key="img-6">
                        <img src="@/assets/images/upgrade-featured/6.svg" alt=" بناء المنتج " />
                    </div>
                    <!-- </transition> -->
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';

// Active feature state
const activeFeatureIndex = ref(0);
const featureAutoPlayInterval = ref<NodeJS.Timeout | null>(null);

const setActiveFeature = (index: number) => {
    activeFeatureIndex.value = index;
    // Reset auto-play timer when user manually clicks
    if (featureAutoPlayInterval.value) {
        clearInterval(featureAutoPlayInterval.value);
    }
    // Restart auto-play after 7.5 seconds
    setTimeout(() => {
        startFeatureAutoPlay();
    }, 7500);
};

const startFeatureAutoPlay = () => {
    if (featureAutoPlayInterval.value) {
        clearInterval(featureAutoPlayInterval.value);
    }

    featureAutoPlayInterval.value = setInterval(() => {
        activeFeatureIndex.value = (activeFeatureIndex.value + 1) % 7; // 7 features total
    }, 5000); // Change every 5 seconds
};

onMounted(() => {
    startFeatureAutoPlay();
});

onUnmounted(() => {
    if (featureAutoPlayInterval.value) {
        clearInterval(featureAutoPlayInterval.value);
    }
});
</script>

<style scoped lang="scss">
.upgrade-features-row {
    display: flex;
    justify-content: center;
    align-items: stretch;
    gap: 24px;
    margin: 32px 0 32px 0;
    flex-wrap: wrap;

    @media (min-width: 1600px) {
        justify-content: space-between;
    }
}

.upgrade-feature-card {
    background: #fff;
    border: 1px solid #EFEFF2;
    border-radius: 16px;
    box-shadow: 0 2px 8px 0 rgba(88, 84, 255, 0.04);
    width: 160px;
    height: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 16px 0 rgba(88, 84, 255, 0.1);
    }

    @media (max-width: 992px) {
        width: 140px;
        height: 80px;
    }
}

.upgrade-feature-card--active {
    border: 2px solid #5854FF;
    box-shadow: 0 0 0 2px #F6F5FF;
}

.upgrade-feature-icon {
    width: 38px;
    height: 38px;
    margin-top: 12px;
}

.upgrade-feature-label {
    font-size: 16px;
    color: #222;
    font-weight: 500;
    text-align: center;
}

@media (max-width: 991px) {
    .upgrade-features-row {
        gap: 12px;
    }

    .upgrade-feature-card {
        width: 110px;
        height: 110px;
    }

    .upgrade-feature-icon {
        width: 36px;
        height: 36px;
    }

    .upgrade-feature-label {
        font-size: 14px;
    }
}

.upgrade-featured-section {
    position: relative;
    background: #fff;
    border-radius: 20px;
    margin-inline: auto;
    border: 1px solid #eee;
    overflow: hidden;
    padding: 0px 0px 32px 24px;
    display: flex;
    align-items: center;
    min-height: 500px;
}

.upgrade-featured-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 0;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        opacity: 0.12;
    }
}

.upgrade-featured-content {
    position: relative;
    z-index: 1;
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    gap: 32px;
}

.upgrade-featured-left {
    flex: 1 1 40%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    min-width: 220px;
}

.upgrade-featured-user-img {
    width: 90%;
    margin-bottom: 18px;

    img {
        width: 100%;
        max-width: 260px;
        border-radius: 12px;
        box-shadow: 0 2px 8px 0 rgba(88, 84, 255, 0.08);
    }
}

.upgrade-featured-testimonial {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px 0 rgba(88, 84, 255, 0.06);
    padding: 16px 20px;
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
}

.upgrade-featured-meta {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 700;
    color: var(--bs-primary);

    .upgrade-featured-meta-logo {
        font-family: inherit;
        font-size: 1rem;
    }

    .upgrade-featured-meta-avatar {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        object-fit: cover;
        border: 2px solid #fff;
        box-shadow: 0 1px 4px 0 rgba(88, 84, 255, 0.08);
    }
}

.upgrade-featured-quote {
    font-size: .75rem;
    color: var(--bs-text-color);
    margin-top: 4px;
}

.upgrade-featured-right {
    flex: 1 1 60%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 16px;
    min-width: 260px;
}

.upgrade-featured-title {
    font-size: 2rem;
    font-weight: 700;
    color: var(--bs-text-color);
    margin-bottom: 8px;
}

.upgrade-featured-desc {
    color: var(--bs-text-color-secondary);
    font-size: 1.1rem;
    margin-bottom: 12px;
}

.upgrade-featured-list {
    list-style: none;
    padding: 0;
    margin: 0 0 18px 0;

    li {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 1rem;
        color: #222;
        margin-bottom: 8px;

        img {
            width: 22px;
            height: 22px;
        }
    }
}


.upgrade-featured-btns {
    display: flex;
    gap: 10px;
    margin-top: 8px;
    flex-wrap: wrap;

    .primary_btn_outline {
        min-width: 160px
    }

    .primary_btn {
        min-width: 160px
    }
}

@media (max-width: 900px) {
    .upgrade-featured-section {
        flex-direction: column;
        padding: 18px 6px;
    }

    .upgrade-featured-content {
        flex-direction: column;
        gap: 18px;
    }

    .upgrade-featured-left,
    .upgrade-featured-right {
        min-width: 0;
        width: 100%;
        align-items: flex-start;
    }

    .upgrade-featured-user-img img {
        max-width: 180px;
    }
}

.upgrade-featured-background-img {
    width: 100%;
    height: 100%;


}

.upgrade-featured-background-img img {
    width: 100%;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
    transition: all 0.5s ease;
}

.fade-slide-enter-from {
    opacity: 0;
    transform: translateX(30px);
}

.fade-slide-leave-to {
    opacity: 0;
    transform: translateX(-30px);
}

.fade-scale-enter-active,
.fade-scale-leave-active {
    transition: all 0.6s ease;
}

.fade-scale-enter-from {
    opacity: 0;
    transform: scale(0.8);
}

.fade-scale-leave-to {
    opacity: 0;
    transform: scale(0.8);
}

// Add smooth transitions to feature cards
.upgrade-feature-card {
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 25px rgba(88, 84, 255, 0.15);
    }

    &--active {
        animation: cardHighlight 0.4s ease-out;
    }
}

@keyframes cardHighlight {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.05);
    }

    100% {
        transform: scale(1);
    }
}

// Add subtle animation to list items
.upgrade-featured-list {
    li {
        opacity: 0;
        animation: fadeInUp 0.6s ease forwards;

        &:nth-child(1) {
            animation-delay: 0.1s;
        }

        &:nth-child(2) {
            animation-delay: 0.2s;
        }

        &:nth-child(3) {
            animation-delay: 0.3s;
        }
    }
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

// Add animation to buttons
.upgrade-featured-btns {
    button {
        transition: all 0.3s ease;

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        }
    }
}
</style>
